import { Container, Paper, Stack } from "@mui/material";
import { Fragment } from "react";
import { Link } from "react-router-dom";
import { getStatusColor } from "../../enums/AppointmentStatus.jsx";
import {
  APPOINTEMENT_DETAILS,
  PENDING_APPOINTEMENT_DETAILS,
  PENDING_APPOINTMENTS,
} from "../../enums/UrlPaths";
import useUser from "../../hooks/useUser.jsx";

export default function AppointmentWrapper({
  children,
  id,
  buttonProps,
  status,
  marginTop,
  fullWidth = false,
}) {
  const { roles } = useUser();
  const redirect =
    PENDING_APPOINTMENTS && roles.adminOrEmployee
      ? PENDING_APPOINTEMENT_DETAILS + `${id}`
      : APPOINTEMENT_DETAILS + `${id}`;

  function renderButtonProps() {
    if (buttonProps != undefined) {
      return true;
    }
    return false;
  }

  function bgColorCondition() {
    return getStatusColor(status);
  }
  const componentSx = {
    borderRadius: 1,
    borderLeftColor: bgColorCondition(),
    borderLeftStyle: "solid",
    borderLeftWidth: 10,
  };
  return (
    <Container
      maxWidth={fullWidth ? false : "lg"}
      disableGutters={fullWidth}
      sx={{
        mt: marginTop ? marginTop : 2,
      }}
    >
      <Link to={redirect} data-testid={`appointment.user-tabs.card.${id}`}>
        <Paper>
          <Stack
            sx={{
              padding: 1,
              transition: "transform 0.25s ease-in-out",
              "&:hover": {
                transform: "scale(1.005)",
              },
              ...componentSx,
            }}
            justifyContent={renderButtonProps() ? "space-between" : ""}
            alignItems={renderButtonProps() ? "center" : ""}
            direction={renderButtonProps() ? "row" : "column"}
          >
            {renderButtonProps() ? (
              <Fragment>
                <Stack
                  sx={{
                    width: { xs: "50%", md: "80%" },
                  }}
                >
                  {children}
                </Stack>
                {buttonProps}
              </Fragment>
            ) : (
              <Fragment>{children}</Fragment>
            )}
          </Stack>
        </Paper>
      </Link>
    </Container>
  );
}
